import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const services = [
    { key: 'ft_svc1' },
    { key: 'ft_svc2' },
    { key: 'ft_svc3' },
    { key: 'ft_svc4' },
  ];

  const companyLinks = [
    { key: 'ft_c1', to: '/nosotros' },
    { key: 'ft_c2', to: '/opiniones' },
    { key: 'ft_c3', to: '/servicios' },
  ];

  const contactItems = [
    { icon: 'ri-phone-line', text: '(754) 249-4067' },
    { icon: 'ri-mail-line', text: 'info@professionalhomemultiservices.com' },
    { icon: 'ri-map-pin-line', text: 'The Villages, FL & Alrededores' },
    { icon: 'ri-time-line', text: t('ft_hours') },
  ];

  return (
    <footer className="bg-brand-blue-dark text-white">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/f95cbe954bd438642a14fc5eded271c5/3b905ef2aa353dd55059444287e04ec9.png"
              alt="Logo empresa limpieza"
              className="h-14 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('ft_desc')}
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-facebook-fill', 'ri-instagram-line', 'ri-whatsapp-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-gray-400 hover:bg-brand-green hover:border-brand-green hover:text-white transition-all cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wide">
              <a href="/servicios">{t('ft_services')}</a>
            </h4>
            <div className="w-10 h-0.5 bg-brand-green mb-4" />
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.key}>
                  <Link to="/servicios" className="text-gray-400 hover:text-brand-green-light text-sm transition-colors cursor-pointer">
                    {t(s.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wide">
              <a href="/nosotros">{t('ft_company')}</a>
            </h4>
            <div className="w-10 h-0.5 bg-brand-blue mb-4" />
            <ul className="space-y-2.5">
              {companyLinks.map((item) => (
                <li key={item.key}>
                  <Link to={item.to} className="text-gray-400 hover:text-brand-green-light text-sm transition-colors cursor-pointer">
                    {t(item.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wide">
              <a href="#contacto">{t('ft_contact')}</a>
            </h4>
            <div className="w-10 h-0.5 bg-brand-green mb-4" />
            <ul className="space-y-3">
              {contactItems.map((item) => (
                <li key={item.icon} className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                    <i className={`${item.icon} text-brand-green text-sm`} />
                  </div>
                  <span className="text-gray-400 text-sm">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs">
            © {new Date().getFullYear()} Professional Home Multiservices. {t('ft_copyright')}
          </p>
          <p className="text-gray-500 text-xs">
            {t('ft_tagline')}
          </p>
        </div>
      </div>
    </footer>
  );
}
